<div class="b2a-header">
  <div class="b2a-header__logo">
    <a routerLink="/">
      <img class="image" src="{{backend}}company/logo/{{user?.company._id}}.png?{{timestamp}}" (error)="showB2ALogo = true" *ngIf="!showB2ALogo && isLoggedIn" alt="Company Logo">
      <img class="image b2a" src="/assets/icons/b2a_logo_transparent.png?{{timestamp}}" *ngIf="showB2ALogo || !isLoggedIn" alt="Back2Action">
    </a>
  </div>
  <div class="b2a-header__text" *ngIf="isLoggedIn">{{'GENERAL.logoSuffix' |translate}}</div>
</div>



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/header/components/logo/logo.component.html